<template>
  <validation-observer ref="formObserver" tag="form">
    <div class="row">
      <div class="col-12">
        <page-header
          left-side-class="col-12 col-md-7"
          :page="headerConfig"
          right-side-class="col-12 col-md-5 d-flex align-items-end mb-2"
        >
          <template #customActions>
            <drop-down
              v-if="showReportDropDown"
              class="mr-2"
              icon="fa fa-folders"
              :items="reportItems"
              title="Informes"
            />
            <action-button
              v-if="canStartHealthReferral"
              id="billing-history-management-button-update-bill"
              class="mr-2"
              i="fas fa-user-plus pr-1"
              text="Comenzar Referido"
              variant="success"
              @click="startReferral"
            />
          </template>
        </page-header>
        <filter-manager
          ref="filterRef"
          v-model="filterModel"
          class="mb-4"
          :filters="filtersConfig"
          @year="onChangeYear"
          @center="onChangeServiceCenter"
          @search="onSearchHandler"
        />
        <custom-separator class="mt-1 mb-4" text="Resultado de Referido" />

        <custom-result-not-found
          v-if="results.length == 0"
          :text="'No hay información disponible.'"
        />
        <template v-else>
          <ResultRow
            v-for="(row, index) of results"
            :key="`result-${index}`"
            class="mb-3"
            :data="row"
            @on-create-pre-register="createPreRegister($event)"
            @on-delete-sie="deleteSie($event)"
            @on-delete-referral="deleteReferral($event)"
            @on-change-status="onChangeStatus()"
          />
          <pagination
            v-if="pagination.totalItemCount > pagination.pageSize"
            :data="pagination"
            show-text
            @pagination-go-page="goToPageHandler"
          />
        </template>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import PageHeader from "PageHeader";
import DropDown from "dropdown";
import ActionButton from "ActionButton";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
import ResultRow from "./components/ResultRow.vue";
import referralStudentService from "@/services/pc/referral-student";
import StudentServices from "@/services/student";
import store from "@/store/index";
import storeMixin from "@quisit/mipe-utils/mixins/storeGenerator";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";
import userRole from "@/utils/constants/userRoles";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";
import generalService from "@/services/pei/general";
import userRoles from "@/utils/constants/userRoles.js";

const DEFAULT_PAGE_SIZE = 20;
const ONLINE_REGISTRATION = 2;

export default {
  name: "ReferralPartCToPartB",
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
    ValidationObserver,
    ValidationProvider,
    DropDown,
    ActionButton
  },
  data: () => ({
    filterModel: {
      year: null,
      period: null,
      student: null,
      partCRegion: null,
      referralStatus: null,
      studentRegStatus: null,
      center: null,
      requestType: null
    },
    filterOptions: {
      years: [],
      periods: [],
      partCRegions: [],
      referralStatuses: [],
      studentRegStatuses: [],
      centers: [],
      requestTypes: []
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 1,
      pageCount: 1,
      count: 1,
      pageSize: DEFAULT_PAGE_SIZE
    },
    results: []
  }),
  computed: {
    isPartCPartB() {
      return this.userRole === userRole.partCPartB;
    },
    hasPersistedInfo() {
      const validPreviousRoutes = ['studentSearchComment', 'detailReferral']
      return (
        !!this.moduleData?.ReferralPartCToPartB &&
        validPreviousRoutes.includes(this.previousRoute?.name)
      );
    },
    headerConfig() {
      return {
        title:
          this.$route.params.type == ONLINE_REGISTRATION
            ? "Manejo de Solicitudes para el Pre-Registro del Estudiante"
            : "Referidos de Parte C a Parte B",
        icon: "fas fa-user-tie",
        routes: [
          "Inicio",
          "Estudiante",
          this.$route.params.type == ONLINE_REGISTRATION
            ? "Manejo de Solicitudes para el Pre-Registro del Estudiante"
            : "Referidos de Parte C a Parte B"
        ]
      };
    },
    filtersConfig() {
      return [
        {
          name: "year",
          component: "CustomDropDown",
          options: this.filterOptions.years,
          placeholder: "Año del Solicitud",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-2",
          clearable: false,
          error: "El Año del solicitud es requerido."
        },
        {
          name: "period",
          component: "CustomDropDown",
          options: this.filterOptions.periods,
          placeholder: "Mes de Solicitud",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          class: "col-12 col-md-3"
        },
        {
          name: "requestType",
          component: "CustomDropDown",
          options: this.filterOptions.requestTypes,
          placeholder: "Tipo de Solicitud",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          class: "col-12 col-md-3",
          disabled: this.isPartCPartB
        },
        {
          name: "student",
          component: "CustomInput",
          placeholder: "Escriba número de solicitud o nombre del estudiante",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          value: this.filterModel.student,
          class: "col-12 col-md-4"
        },
        {
          name: "center",
          component: "CustomDropDown",
          options: this.filterOptions.centers,
          label: "CSEE:",
          placeholder: "Seleccione",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          isAdvanced: true,
          class: "col-12 col-md-3",
          visible: !this.isPartCPartB
        },
        ...(this.canFilterByRegion
          ? [
              {
                name: "partCRegion",
                component: "CustomDropDown",
                options: this.filterOptions.partCRegions,
                label: "Región Parte C:",
                placeholder: "Seleccione",
                fieldName: "name",
                fieldKey: "id",
                clearable: true,
                isAdvanced: true,
                class: "col-12 col-md-3"
              }
            ]
          : []),
        {
          name: "referralStatus",
          component: "CustomDropDown",
          options: this.filterOptions.referralStatuses,
          label: this.requestStatusLabel,
          placeholder: "Seleccione",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          class: "col-12 col-md-3",
          isAdvanced: true
        },
        {
          name: "studentRegStatus",
          component: "CustomDropDown",
          options: this.filterOptions.studentRegStatuses,
          label: "Estatus del Estudiante EE:",
          placeholder: "Seleccione",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          class: "col-12 col-md-3",
          isAdvanced: true
        }
      ];
    },
    showReportDropDown() {
      return this.userHasPermissions(
        "student.referralcparttobpart.viewreportaction"
      );
    },
    canDownloadHealthReferralReport() {
      return this.userHasPermissions(
        "student.referralcparttobpart.downloadhealthreferralreport"
      );
    },
    canDownloadPreregistrationRequestReport() {
      return this.userHasPermissions(
        "student.referralcparttobpart.downloadpre-registrationrequestreport"
      );
    },
    reportItems() {
      return [
        {
          label: "Referidos de Salud",
          icon: "fa fa-file-alt color-green",
          visible: this.canDownloadHealthReferralReport,
          click: () => this.onDownloadStudentHealthReferralReport()
        },
        {
          label: "Preregistro en Línea",
          icon: "fa fa-file-alt color-green",
          click: () => this.downloadStudentPreregister(),
          visible: this.canDownloadPreregistrationRequestReport,
          border: "top"
        }
      ];
    },
    requestStatusLabel() {
      return this.isPartCPartB
        ? "Estatus de Referido:"
        : "Estatus de Solicitud:";
    },
    canStartHealthReferral() {
      return this.userHasPermissions(
        "student.partcpartbreferral.view.starthealthreferral"
      );
    },
    canFilterByRegion() {
      const availableRoles = [
        userRoles.partCPartB,
        userRoles.adminIl,
        userRoles.admin,
        userRoles.adminSaee
      ];
      return availableRoles.includes(this.userRole);
    },
    isOnlineRegistrationType() {
      return this.$route.params.type == ONLINE_REGISTRATION;
    },
  },
  async mounted() {
    if(store.state.$_student.showSelectedStudent)
      store.state.$_student.showSelectedStudent = false;
    
    await this.getInitFilters();

    if (!this.hasPersistedInfo) {
      this.filterModel.center = null;
      this.filterModel.partCRegion = null;

      if (this.filterOptions.partCRegions.length === 1) {
        const firstAndOnlyHealthRegion = this.filterOptions.partCRegions[0];
        this.filterModel.partCRegion = {
          ...firstAndOnlyHealthRegion,
          disabled: true
        };
      }

      if (!this.isPartCPartB) {
        if (this.filterOptions.centers.length === 1) {
          const firstAndOnlyCenter = this.filterOptions.centers[0];
          this.filterModel.center = {
            ...firstAndOnlyCenter,
            disabled: true
          };

          await this.onChangeServiceCenter();
        }
      }

      this.filterModel = {
        ...this.filterModel,
        period: null,
        student: null,
        partCRegion: this.filterModel.partCRegion,
        referralStatus: null,
        studentRegStatus: null,
        center: this.filterModel.center,
        requestType: null,
      };
      
      if (this.filterOptions.requestTypes.length) {
        this.filterModel.requestType = this.isOnlineRegistrationType
          ? this.filterOptions.requestTypes[1] : this.filterOptions.requestTypes[0];
      }

      this.results = [];
      await this.onSearchHandler();
      return;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.previousRoute = from));
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getInitFilters() {
      if (this.hasPersistedInfo) {
        this.onSearchHandlerWhenPersist(this.pagination.currentPage);
      } else {
        const { filters, collections } = (
          await referralStudentService.getInitFilters()
        ).data;

        this.filterModel = {
          ...this.filterModel,
          ...filters
        };
        this.filterOptions = {
          ...this.filterOptions,
          ...collections
        };
      }
    },
    async onChangeYear(value) {
      if (value?.id) {
        const { data } = await referralStudentService.getMonthsByYear(value.id);
        this.filterOptions.periods = data;
        this.filterModel.period = null;
      }
    },
    async onChangeServiceCenter() {
      const payload = {
        centerId: this.filterModel.center?.id
      };
      const { data } = await referralStudentService.getRegions(payload);
      this.filterOptions.partCRegions = data;
      this.filterModel.partCRegion = null;
    },
    fillPayload(page) {
      const payload = {
        academicYearId: this.filterModel.year?.id,
        monthNumber: this.filterModel.period?.id,
        studentNameOrRequestNumber: this.filterModel.student,
        partCRegionId: this.filterModel.partCRegion?.id,
        statusId: this.filterModel.referralStatus?.id,
        studentRegStatusId: this.filterModel.studentRegStatus?.id,
        centerId: this.filterModel.center?.id,
        requestTypeId: this.filterModel.requestType?.id,
        pageIndex: page ? page : 1,
        pageSize: this.pagination.pageSize
      };

      if (payload.partCRegionId)
        payload.requestTypeId = publicPortalRequestTypes.HealthReferral;

      return payload;
    },
    async onSearchHandler() {
      const pageIndex = 1;
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }
      const payload = this.fillPayload(pageIndex);
      this.search(payload);
    },
    async onSearchHandlerWhenPersist(pageIndex) {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }
      const payload = this.fillPayload(pageIndex);
      this.search(payload);
    },
    async search(payload) {
      const res = (await referralStudentService.search(payload)).data;
      this.results = res.data.map(item => ({
        ...item,
        isOpen: false
      }));
      this.pagination = {
        ...this.pagination,
        count: res.count,
        currentPage: res.currentPage,
        pageCount: res.pageCount,
        totalItemCount: res.totalItemCount
      };
    },
    async goToPageHandler(page) {
      const payload = this.fillPayload(page);
      await this.search(payload);
    },
    async createPreRegister(student) {
      let data;

      if (student.requestTypeId == publicPortalRequestTypes.HealthReferral) {
        const {
          data: dataResult
        } = await referralStudentService.validateCreationPreRegister(
          student.pcStudentId
        );
        data = dataResult;
      } else {
        const {
          data: dataResult
        } = await StudentServices.validateCreationPreRegisterFromPublicPortal(
          student.pcStudentId
        ).catch(err => {
          this.ShowToast(
            "Alerta",
            err.response.data.message || "error",
            "error"
          );
        });
        data = dataResult;
      }

      if (data.hasOwnProperty("isValid") && !data?.isValid) {
        this.ShowToast("Error", data.errorMessage, "error");
        return;
      }

      let confirmResult = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro(a) que desea realizar el pre-registro del estudiante ${student.fullName}-${student.studentSieId}?`,
        "Si",
        "No"
      );
      if (confirmResult) {
        if (student.requestTypeId == publicPortalRequestTypes.HealthReferral) {
          const { data } = await referralStudentService.createPreRegister(
            student.pcStudentId
          );
          student.completedDate = data.completedDate;
          student.modifiedBy = data.modifiedBy;
          student.modifiedDate = data.modifiedDate;
          student.referralStatus = data.referralStatus;
          student.referralStatusId = data.referralStatusId;
          student.studentRegStatus = data.studentRegStatus;
        } else {
          await StudentServices.createPreRegisterFromPublicPortal(
            student.pcStudentId
          );
        }

        this.ShowToast(
          "Proceso exitoso",
          "Se ha creado el pre-registro del estudiante exitosamente.",
          "success"
        );
        await this.onSearchHandler();
      }
    },
    async deleteSie(student) {
      let confirmResult = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro(a) que desea eliminar la relación del SIE ${student.studentSieId} al estudiante ${student.fullName}?`,
        "Si",
        "No"
      );
      let deleted = false;
      if (confirmResult) {
        if (student.requestTypeId == publicPortalRequestTypes.HealthReferral) {
          const { data } = await referralStudentService.deleteRelatedStudentSie(
            student.pcStudentId
          );
          deleted = data;
        } else {
          const { data } = await StudentServices.deleteRelatedStudentSie(
            student.pcStudentId
          );
          deleted = data;
        }

        if (deleted) {
          this.ShowToast(
            "Proceso exitoso",
            "Se eliminó la relación del SIE del estudiante exitosamente.",
            "success"
          );
          await this.onSearchHandler();
        }
      }
    },
    async deleteReferral(item) {
      let confirmResult = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro(a) que desea eliminar la solicitud ${item.caseNumber}?`,
        "Si",
        "No"
      );
      let deleted = false;
      if (confirmResult) {
        if (item.requestTypeId == publicPortalRequestTypes.HealthReferral) {
          const { data } = await referralStudentService.deleteReferral(
            item.pcStudentId
          );
          deleted = data;
        } else {
          const { data } = await StudentServices.deleteReferral(
            item.pcStudentId
          );
          deleted = data;
        }

        if (deleted) {
          this.ShowToast(
            "Proceso exitoso",
            "La solicitud ha sido eliminada exitosamente.",
            "success"
          );
          await this.onSearchHandler();
        }
      }
    },
    startReferral() {
      this.$router.push({ path: "/student/startReferral" });
    },
    async downloadStudentPreregister() {
      let report = `studentpreregister/${this.filterModel.year?.id}`;
      await generalService.downloadMipeReport(report);
      return;
    },
    async onDownloadStudentHealthReferralReport() {
      await generalService.downloadMipeReport(
        `studenthealthreferral/${this.filterModel.year?.id}`
      );
    },
    async onChangeStatus() {
      await this.onSearchHandler();
    }
  }
};
</script>
